import { Component, Entity2D } from '../../../odie';
import { app } from '../../app';
import { ColorId, CountBlockOptionDef } from '../../defs/block';
import {
  BalloonBoxBlockProps,
  BalloonBoxState,
  BalloonBoxStateFlag,
  balloonBoxOptionToState,
  balloonBoxStateToOption,
} from './BalloonBoxBlock';
import { BalloonBoxBlockView } from './BalloonBoxBlockView';

export type BalloonBoxBlockComponentOptions = {
  props: BalloonBoxBlockProps;
  option?: number;
};

export class BalloonBoxBlockComponent implements Component {
  public static readonly NAME = 'blockBalloonBox';
  public entity!: Entity2D;
  public view!: BalloonBoxBlockView;
  private props!: BalloonBoxBlockProps;
  private state!: BalloonBoxState;

  public init(args: BalloonBoxBlockComponentOptions): void {
    this.props = args.props;
    this.view = new BalloonBoxBlockView(args.props);
    this.state = balloonBoxOptionToState(args.option ?? 0);
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
    this.view.updateBalloons(this.state);
  }

  public getGameplayState(): number {
    return balloonBoxStateToOption(this.state);
  }

  public fillBalloon(color: ColorId) {
    // Balloon Box does not get hit by purple
    if (color === 'purple') return false;
    const balloonA = `${color}A` as BalloonBoxStateFlag;
    const balloonB = `${color}B` as BalloonBoxStateFlag;
    let filledUp = false;
    if (!this.state[balloonA]) {
      this.state[balloonA] = true;
      filledUp = true;
    } else if (!this.state[balloonB]) {
      this.state[balloonB] = true;
      filledUp = true;
    }
    this.view.updateBalloons(this.state);
    return filledUp;
  }

  public async explode() {
    await this.view.explode();
  }

  public getState() {
    return this.state;
  }
}
